module.exports = __webpack_public_path__ + "static/atlassian.f447994f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/atlassian.png
// module id = 840
// module chunks = 73261030922168